import { createApp } from 'vue';
import App from './App.vue';
import i18n from './lang/i18n';
import './registerServiceWorker';
import Quasar from 'quasar/src/vue-plugin.js';;
import quasarUserOptions from './quasar-user-options';
createApp(App).use(Quasar, quasarUserOptions).use(i18n).mount('#app');
